<template>
    <div class="login">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm from_Phone">
            <div class="title">
                欢迎登录
            </div>
            <el-form-item prop="userName" class="from_text">
                <el-input prefix-icon="el-icon-user" placeholder="用户名" @focus="focus" @blur="blur" res="userName"
                          type="userName" class="transparent-input" v-model="ruleForm.userName"
                          style=" width: 70vw;border-bottom: 2px solid rgba(255, 255, 255, 0.6);"></el-input>
            </el-form-item>
            <el-form-item prop="password" class="from_text">
                <el-input prefix-icon="el-icon-user" placeholder="密码" @focus="focus" @blur="blur" res="password"
                          type="password" class="transparent-input" v-model="ruleForm.password"
                          style=" width: 70vw;border-bottom: 2px solid rgba(255, 255, 255, 0.6);"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button style="border-radius: 6px; height: 2.5rem; letter-spacing: 0.3rem; width: 60vw;"
                           type="primary" @click="submitForm('ruleForm')" :loading="isLoading">登录
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import axios from 'axios';
import {baseUrl} from "@/utils/base";

export default {
    data() {
        return {
            ruleForm: {
                userName: '',
                password: '',
            },

            state: true,
            obtainCodeState: false,
            codeNum: 60,
            userCode: '',
            isLoading: false,
        }
    },
    methods: {
        blur() {
            this.$emit('blur')
        },
        focus() {
            this.$emit('focus')
        },
        async submitForm(ruleForm) {
            this.isLoading = true;
            if (this.ruleForm.userName == '' && this.ruleForm.password == '') {
                this.$message({
                    message: '输入的用户名或密码不正确，请重新输入',
                    type: 'error',
                    duration: 2000
                })
                return
            }
            const res = await axios({
                url: `${baseUrl}/login/login`,
                method: "post",
                data: {
                    loginName: this.ruleForm.userName,
                    loginPass: this.ruleForm.password,
                    domainName: 'cssjj.admot.cn',
                },
            });
            console.log("res", res.data)
            if (+res.data.rescode === 200) {
                window.sessionStorage.setItem('token', res.data.data.token);
                window.sessionStorage.setItem('userInfo', JSON.stringify( res.data.data.user));
                window.sessionStorage.setItem('userCode', res.data.data.user.userCode);
                this.isLoading = false;
                this.$message({
                    message: '登录成功',
                    type: 'success',
                    duration: 2000
                })
                this.$router.push('/monitor')
                return
            }else {
                this.isLoading = false;
                this.$message({
                    message: res.data.msg,
                    type: 'error',
                    duration: 2000
                })
                return
            }
        },
    }
}
</script>

<style scoped>
.login {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("@/assets/login.png");
}

.login .title {
    z-index: 9999;
    font-size: 26px;
    margin: 10px 0;
}

.from_Phone {
    position: absolute;
    border: none;
    line-height: 2.5rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80vw;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    height: 14rem;
    color: #FFF;
    font-size: 16px;
    top: 30%;
    z-index: 2;
    padding-top: 10px;
    background-color: rgba(0, 0, 0, 0.5);
}

input:focus {
    border: none;
}

.transparent-input .el-input__inner {
    background-color: transparent;
    border: none;
}

.transparent-input .el-input-group__append {
    background-color: transparent;
    border: none;
    color: #FFF;
}
</style>
